
import { ResultData } from "@nt-portal/common-sdk";

import {  HashResponse, TCMRunProcess, TCMResponse, TCMResponseService, TCMResponseSearch } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { initTCMSchedule } from "../schedule";
import { randomColor } from "../../../../common";

export interface TCMResponseOptions extends ControllerOptions<TCMResponse> {
    scheduleId?: string;
    mine?: boolean;
}

export const createTCMResponse = (inObj: Partial<TCMResponse>) => {
    let item: TCMResponse = {
        schedule: initTCMSchedule(),
        name: "",
        hash: "",
        color: randomColor(),
        createdBy: "",
        supplier: {
            name: "",
            createdBy: ""
        },
        fileName: "",
        goalResults: [],
        supplierValid: true
    }
    return item;
}

export class ClientTCMResponseService extends BaseClientService implements DataController<TCMResponse> {

    private _service: TCMResponseService;


    constructor() {
        super();
        this._service = new TCMResponseService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMResponseOptions): Promise<ResultData<TCMResponse>> {
        let search: TCMResponseSearch  = {
            filter: options.filter ?? "",
            schedule: options.scheduleId ?? "",
            mine: options.mine ?? false
        }

        return await this._service.get(this.buildFetchParams(options), this.token, search);

    }
    public async getLookup(options: TCMResponseOptions): Promise<ResultData<TCMResponse>> {
        let fetchParams = this.buildLookupFetchParams(options);
       
       let search: TCMResponseSearch  = {
            filter: options.filter ?? "",
            schedule: options.scheduleId ?? "",
            mine: options.mine ?? false
        }

        let data = await this._service.get(fetchParams, this.token, search);
        return data;
    }

    public async getById(options: TCMResponseOptions): Promise<TCMResponse | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMResponseOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMResponseOptions): Promise<TCMResponse | TCMResponse[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMResponseOptions): Promise<TCMResponse | TCMResponse[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async clone(options: TCMResponseOptions): Promise<TCMResponse | TCMResponse[] | null> {
        if (options.item && options.id)
            return await this._service.clone(options.id, options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async import(options: TCMResponseOptions): Promise<any> {
        if (options.file && options.item) {
            return await this._service.importExcel(options.file, options.item, this.token);
        }
    }

    public async export(options: TCMResponseOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

    public async getByHash(hash: string): Promise<HashResponse> {
        return await this._service.findByHash( this.token, { hash: hash});
    }

    public async validateGoals(responseId: string): Promise<TCMRunProcess> {
        return await this._service.validateGoals(this.token, responseId);
    }

    public async validateDuplicate(scheduleId: string, supplierId: string, id?: string): Promise<TCMResponse | null> {
        return await this._service.validateDuplicate(this.token, scheduleId, supplierId, id);
    }
   
}